import Content from "Types/Content";
import RunicMemorise from "./RunicMemorise";
import { GameContextProvider } from "./RunicMemoriseContext";

const Game = () => {
  return (
    <GameContextProvider>
      <RunicMemorise />
    </GameContextProvider>
  );
};

export default new Content({
  Component: Game,
  title: "Runic Memorise",
  route: "runic-memorise"
});
